import React from "react";

const OrdersLoading = () => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-lg border border-gray-800 bg-gray-900 p-6"
        >
          {/* Header with status badge */}
          <div className="mb-4 flex items-center justify-between">
            <div className="h-6 w-20 rounded-full bg-gray-700"></div>
            <div className="h-5 w-16 rounded bg-gray-700"></div>
          </div>

          {/* Order ID */}
          <div className="mb-3 h-5 w-24 rounded bg-gray-700"></div>

          {/* Customer info */}
          <div className="mb-4 space-y-2">
            <div className="h-4 w-32 rounded bg-gray-700"></div>
            <div className="h-4 w-28 rounded bg-gray-700"></div>
          </div>

          {/* Order items */}
          <div className="mb-4 space-y-2">
            <div className="h-3 w-full rounded bg-gray-700"></div>
            <div className="h-3 w-3/4 rounded bg-gray-700"></div>
            <div className="h-3 w-1/2 rounded bg-gray-700"></div>
          </div>

          {/* Total */}
          <div className="mb-4 h-5 w-20 rounded bg-gray-700"></div>

          {/* Footer buttons */}
          <div className="flex space-x-2">
            <div className="h-8 w-20 rounded bg-gray-700"></div>
            <div className="h-8 w-24 rounded bg-gray-700"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersLoading;
